import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ProductDetailAdd" })
export default class ProductDetailAdd extends Vue {
    public localizer: any = Localizer;
    public validationErrors: any[] = [];
    public isLoadingForm: boolean = false;
    public productItems: any[] = [];
    public formData: any = { price: 0, productQuantity: 1, maxCartQuantity: 1, isDigital: false };
    public selectedProduct: any = {};
    public isPayPalMessageVisible: boolean = false;
    public payPalPayment: number = 0.0;
    public deliveryDate: string = null;

    get encodedFilters(): any {
        return this.$store.getters["catalogueStore/encodedFilters"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly familyCode: string;
    @Prop() readonly orderCode: string;

    @Watch("encodedFilters") onEncodedFiltersChanged(value: string) {
        this.getData(value);
    }

    @Watch("selectedProduct") onSelectedProductChanged(value: any) {
        if (value.priceOffer != null && value.priceOffer >= 30 && value.priceOffer <= 2000) {
            this.isPayPalMessageVisible = true;
            this.payPalPayment = value.priceOffer / 3;
        } else if (value.priceOffer == null && value.price >= 30 && value.price <= 2000) {
            this.isPayPalMessageVisible = true;
            this.payPalPayment = value.price / 3;
        } else {
            this.isPayPalMessageVisible = false;
            this.payPalPayment = 0.0;
        }
    }

    public async created() {
        await this.getData(this.encodedFilters);
    }

    public async getData(encodedFilters: string) {
        const response = (await Axios.post(this.routes.Catalogue_GetStoreProducts, { familyCode: this.familyCode, filter: encodedFilters })).data;

        this.productItems = response.products;
        this.deliveryDate = response.deliveryDate;

        if (this.productItems.length !== 0 && !this.orderCode) {
            this.formData.productCode = this.productItems[0].orderCode;
            this.formData.price = this.productItems[0].price;
            this.formData.priceOffer = this.productItems[0].priceOffer;
            this.formData.productQuantity = 1;
            this.formData.maxCartQuantity = this.productItems[0].maxCartQuantity;
            this.formData.isCartDisabled = this.productItems[0].isCartDisabled;
            this.formData.isDigital = this.productItems[0].isDigital;
            this.formData.storeAlertDescription = this.productItems[0].storeAlertDescription;
            this.formData.supportMessage = this.productItems[0].supportMessage;

            this.selectedProduct = this.productItems[0];
        } else if (this.productItems.length !== 0 && this.orderCode && this.productItems.find(x => x.orderCode === this.orderCode)) {
            this.formData.productCode = this.productItems.find(x => x.orderCode === this.orderCode).orderCode;
            this.formData.price = this.productItems.find(x => x.orderCode === this.orderCode).price;
            this.formData.priceOffer = this.productItems.find(x => x.orderCode === this.orderCode).priceOffer;
            this.formData.productQuantity = 1;
            this.formData.maxCartQuantity = this.productItems.find(x => x.orderCode === this.orderCode).maxCartQuantity;
            this.formData.isCartDisabled = this.productItems.find(x => x.orderCode === this.orderCode).isCartDisabled;
            this.formData.isDigital = this.productItems.find(x => x.orderCode === this.orderCode).isDigital;
            this.formData.storeAlertDescription = this.productItems.find(x => x.orderCode === this.orderCode).storeAlertDescription;
            this.formData.supportMessage = this.productItems.find(x => x.orderCode === this.orderCode).supportMessage;

            this.selectedProduct = this.productItems.find(x => x.orderCode === this.orderCode);
        }

        GTagHelper.sendCustomEvent("view_item", {
            currency: "EUR",
            value: this.formData.priceOffer ? this.formData.priceOffer : this.formData.price,
            items: [
                {
                    item_id: this.formData.productCode,
                    item_name: this.selectedProduct.title,
                    affiliation: "Beghelli",
                    currency: "EUR",
                    item_category: this.selectedProduct.categoryName,
                    price: this.formData.price,
                    discount: this.formData.priceOffer ? this.formData.price - this.formData.priceOffer : 0
                }
            ]
        });
    }

    public async changeProduct(product: any) {
        if (this.orderCode) {
            window.location.href = product.detailUrl;
            return;
        }

        this.formData.productCode = this.productItems.find(x => x.orderCode === product.orderCode).orderCode;
        this.formData.price = this.productItems.find(x => x.orderCode === product.orderCode).price;
        this.formData.priceOffer = this.productItems.find(x => x.orderCode === product.orderCode).priceOffer;
        this.formData.maxCartQuantity = this.productItems.find(x => x.orderCode === product.orderCode).maxCartQuantity;
        this.formData.isCartDisabled = this.productItems.find(x => x.orderCode === product.orderCode).isCartDisabled;
        this.formData.isDigital = this.productItems.find(x => x.orderCode === product.orderCode).isDigital;
        this.formData.storeAlertDescription = this.productItems.find(x => x.orderCode === product.orderCode).storeAlertDescription;
        this.formData.supportMessage = this.productItems.find(x => x.orderCode === product.orderCode).supportMessage;
        this.formData.productQuantity = 1;

        this.selectedProduct = this.productItems.find(x => x.orderCode === product.orderCode);
    }

    public addQuantity() {
        this.formData.productQuantity ? this.formData.productQuantity++ : this.formData.productQuantity = 1;

        if (this.formData.productQuantity > 100) {
            this.formData.productQuantity = 100;
        }
    }

    public removeQuantity() {
        this.formData.productQuantity > 1 ? this.formData.productQuantity-- : this.formData.productQuantity = 1;
    }

    public getCart() {
        this.$store.dispatch("cartStore/getCart");
    }

    public async addProduct() {
        FormHelper.removeFocus();
        this.isLoadingForm = true;
        this.validationErrors = [];

        if (isNaN(this.formData.productQuantity) || this.formData.productQuantity === "") {
            this.validationErrors.push({ name: "Quantity", message: this.localizer.get("Store.Common.Error_QuantityNotValid") });
        } else {
            try {
                await Axios.post(this.routes.StoreCart_AddProduct, this.formData);

                this.getCart();

                this.$store.commit("cartStore/setIsCartPreviewShow", true);

                GTagHelper.sendCustomEvent("add_to_cart", {
                    currency: "EUR",
                    value: (this.formData.priceOffer ? this.formData.priceOffer : this.formData.price) * this.formData.productQuantity,
                    items: [
                        {
                            item_id: this.formData.productCode,
                            item_name: this.selectedProduct.title,
                            affiliation: "Beghelli",
                            currency: "EUR",
                            item_category: this.selectedProduct.categoryName,
                            price: this.formData.price,
                            discount: this.formData.priceOffer ? this.formData.price - this.formData.priceOffer : 0,
                            quantity: this.formData.productQuantity
                        }
                    ]
                });
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoadingForm = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }
};